// @flow
import React from "react";
import RightChevronSvg from "../../../svg/rightChevron.svg";

import "./rightChevronIcon.scss";

const RightChevronIcon = () => (
  <RightChevronSvg className="c-right-chevron-icon" />
);

export default RightChevronIcon;
